import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';
import { useSetPersonDocumentVisibility } from '@dealstack/frontend/shared/components/Documents/hooks/useSetPersonDocumentVisibility';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationDocuments } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	dealId: string;
	documentId: string;
	personId: string;
	visibleToInvestor: boolean;
}

/**
 * DC-494: per-link control over whether a person sees this document in their investor portal.
 * Turning it off leaves the document/person link intact.
 */
export const InvestorVisibilityToggle = ({
	dealId,
	documentId,
	personId,
	visibleToInvestor,
}: Props) => {
	const tDocuments = useTranslationDocuments();
	const { mutateAsync: setVisibility, isPending } = useSetPersonDocumentVisibility();

	const handleChange = async (nextVisible: boolean) => {
		try {
			await setVisibility({
				dealId,
				documentId,
				personIds: [personId],
				visibleToInvestor: nextVisible,
			});
		} catch {
			showToastV2({
				title: tDocuments('investor_visibility.update_error'),
				state: 'error',
			});
		}
	};

	const stateLabel = visibleToInvestor
		? tDocuments('investor_visibility.state_visible')
		: tDocuments('investor_visibility.state_hidden');

	return (
		<AdvancedSwitch
			selectedValue={visibleToInvestor}
			disabled={isPending}
			onChange={(value) => handleChange(value === true)}
			rightText={stateLabel}
		/>
	);
};
